import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight } = FiIcons;

export default function ProjectCard({ project }) {
  return (
    <article className="project-card">
      <div className="project-image-wrap">
        <img src={project.image} alt={project.title} className="project-image" />
        <span className="project-arrow"><SafeIcon icon={FiArrowUpRight} /></span>
      </div>
      <div className="project-meta">
        <div>
          <span className="card-category">{project.category}</span>
          <h3>{project.title}</h3>
        </div>
        <p>{project.description}</p>
      </div>
      <button className="text-link" type="button">
        View Project <SafeIcon icon={FiArrowUpRight} />
      </button>
    </article>
  );
}